import React from 'react';
import Joyride from 'react-joyride';
import {
  LayoutWrapper,
  Content
} from '../../../../components/reusableComponents/ParentWrapper/ParentWrapper';
import CoachTooltip from '../../../../components/Coach/CoachTooltip';
import Modal from '../../../../components/Modal';

/**
 * Shared page layout for Teams and WebTeams pages
 * Handles coach marks, modals, loading states, and common layout structure
 */
const TeamsPageLayout = ({
  children,
  loading = false,
  showCoachMarks = false,
  coachMarksVisited = false,
  coachMarksSteps = [],
  onCoachMarkComplete,
  modals = [],
  dataTestId = 'teams-data-view'
}) => {
  return (
    <>
      {showCoachMarks && !loading && (
        <Joyride
          tooltipComponent={(props) => (
            <CoachTooltip {...props} onCoachSkippedOrFinished={onCoachMarkComplete} />
          )}
          continuous
          run={!coachMarksVisited}
          showProgress
          showSkipButton
          steps={coachMarksSteps}
          disableOverlayClose={true}
          disableCloseOnEsc={true}
          spotlightPadding={0}
        />
      )}

      <LayoutWrapper data-testid={dataTestId}>
        <Content>{children}</Content>
      </LayoutWrapper>

      {modals.map((modal, index) => (
        <Modal
          key={index}
          state={modal.state}
          backgroundStyle={
            modal.backgroundStyle || {
              background: 'rgba(var(--ng-neutral-90), 0.5)',
              backdropFilter: 'blur(2px)'
            }
          }>
          {modal.content}
        </Modal>
      ))}
    </>
  );
};

export default TeamsPageLayout;
